<template>
    <div class="prism-player" id="J_prismPlayer" style="height:100%;"></div>
</template>
<script>
    import {
        getCourseVideoPlayauth
    } from '../../api/edu.js'
    export default {
        name: 'VideoPlayHome',
        data() {
            return {
                sourceKey: "",
                player: null,
                //没有进度条
                sowingSkinLayout: [{
                        "name": "bigPlayButton",
                        "align": "blabs",
                        "x": 30,
                        "y": 80
                    },
                    {
                        "name": "H5Loading",
                        "align": "cc"
                    },
                    {
                        "name": "errorDisplay",
                        "align": "tlabs",
                        "x": 0,
                        "y": 0
                    },
                    {
                        "name": "infoDisplay"
                    },
                    {
                        "name": "tooltip",
                        "align": "blabs",
                        "x": 0,
                        "y": 56
                    },
                    {
                        "name": "thumbnail"
                    },
                    {
                        "name": "controlBar",
                        "align": "blabs",
                        "x": 0,
                        "y": 0,
                        "children": [{
                                "name": "playButton",
                                "align": "tl",
                                "x": 15,
                                "y": 12
                            },
                            {
                                "name": "timeDisplay",
                                "align": "tl",
                                "x": 10,
                                "y": 7
                            },
                            {
                                "name": "fullScreenButton",
                                "align": "tr",
                                "x": 10,
                                "y": 12
                            },
                            {
                                "name": "volume",
                                "align": "tr",
                                "x": 5,
                                "y": 10
                            }
                        ]
                    }
                ],
                //有进度条
                noSowingskinLayout: [{
                        "name": "bigPlayButton",
                        "align": "blabs",
                        "x": 30,
                        "y": 80
                    },
                    {
                        "name": "H5Loading",
                        "align": "cc"
                    },
                    {
                        "name": "errorDisplay",
                        "align": "tlabs",
                        "x": 0,
                        "y": 0
                    },
                    {
                        "name": "infoDisplay"
                    },
                    {
                        "name": "tooltip",
                        "align": "blabs",
                        "x": 0,
                        "y": 56
                    },
                    {
                        "name": "thumbnail"
                    },
                    {
                        "name": "controlBar",
                        "align": "blabs",
                        "x": 0,
                        "y": 0,
                        "children": [{
                                "name": "progress",
                                "align": "blabs",
                                "x": 0,
                                "y": 44
                            },
                            {
                                "name": "playButton",
                                "align": "tl",
                                "x": 15,
                                "y": 12
                            },
                            {
                                "name": "timeDisplay",
                                "align": "tl",
                                "x": 10,
                                "y": 7
                            },
                            {
                                "name": "fullScreenButton",
                                "align": "tr",
                                "x": 10,
                                "y": 12
                            },
                            {
                                "name": "volume",
                                "align": "tr",
                                "x": 5,
                                "y": 10
                            }
                        ]
                    }
                ],
                videoItem: {},
                x5_fullscreen: false
            }
        },
        // props: {
        //     tryWatchTime: {
        //         type: Number,
        //         required: 0
        //     },
        //     tryWatchStr: {
        //         type: String,
        //         required: ''
        //     }
        // },
        methods: {
            getCourseVideoPlayauth(sourceKey) {
                getCourseVideoPlayauth(sourceKey).then(res => {
                    if (res.code == 200) {
                        this.videoItem = res.data;
                        this.inIt(sourceKey, this.videoItem.playAuth, this.videoItem.coverURL,
                            this.noSowingskinLayout);
                    }
                })
            },
            //初始化控件
            inIt(vid, playauth, cover, skinLayout) {
                if (this.player !== null) {
                    this.player.dispose();
                }
                this.player = new Aliplayer({
                    id: 'J_prismPlayer',
                    autoplay: true,
                    showBarTime: 3000000,
                    skinLayout: skinLayout,
                    useH5Prism: true,
                    vid: vid,
                    playauth: playauth,
                    cover: cover,
                    // components: [{
                    //     name: 'PreviewVodComponent',
                    //     type: AliPlayerComponent.PreviewVodComponent,
                    //     args: [this.tryWatchTime,
                    //         this.tryWatchStr,
                    //         this.tryWatchStr
                    //     ]
                    // }]
                }, (player) => {
                    player.on('pause', () => {
                        console.log('暂停播放');
                    });
                });
            },

            //暂停事件
            pause() {
                this.player.pause();
            },
        },

    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/courseView/TryWatchVideoPlay.vue